import React from 'react'
import ReactDOM from 'react-dom'
import SharedViewAppProto from 'shared-view/core/app-proto'

import RequestForm from "../../../app/tools/request-forms2/model/request-form"
import AppLayout from '../../../core/gd-app/component/app-layout.tsx'
import Main from './main/main'

export default class AppRequestForm extends SharedViewAppProto {

    constructor() {
        super()
    }

    async start() {
        try {
            const response = await gd.api.SharedView.getData(this.publicKey).promise()

            this.requestForm = await RequestForm.initFromConfig(response)
            this.render()
        } catch (e) {
            console.error("AppRequestForm error:", e)
            gd.growl.removeAll()
            this.renderNotFound()
        }
    }

    render() {
        ReactDOM.render(
            <AppLayout className="edit-request-form">
                <Main app={this} />
            </AppLayout>,
            document.getElementById(this.domContainer)
        )
    }
}
